<script lang="ts">
  import { Lexer } from 'marked';
  import Block from './Block.svelte';

  interface Props {
    md: string;
  }
  let { md }: Props = $props();

  let tokens = $derived(Lexer.lex(md));
</script>

<Block {tokens} />
